import { render, staticRenderFns } from "./Pdv.vue?vue&type=template&id=33bc3984&"
import script from "./Pdv.vue?vue&type=script&setup=true&lang=js&"
export * from "./Pdv.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports